module.exports = __webpack_public_path__ + "img/plant_6.d3a730f1.webp";